(function(){
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-vc-pick]');
    if (t) {
      var g = t.closest('[data-vc-group]');
      if (g) {
        g.querySelectorAll('[data-vc-pick]').forEach(function(b){ b.classList.remove('is-on'); b.setAttribute('aria-pressed','false'); });
        t.classList.add('is-on'); t.setAttribute('aria-pressed','true');
        g.querySelectorAll('[data-vc-out]').forEach(function(o){ var k = o.getAttribute('data-vc-out'); if (t.dataset[k] !== undefined) o.textContent = t.dataset[k]; });
        if (t.dataset.w) { var bag = g.querySelector('.vc-bag'); if (bag) { bag.style.width = t.dataset.w + 'px'; bag.style.height = t.dataset.h + 'px'; bag.style.borderRadius = t.dataset.r; } }
        var f = t.getAttribute('data-vc-filter');
        if (f !== null) { g.querySelectorAll('[data-vc-cat]').forEach(function(i){ i.hidden = !(f === 'All' || i.getAttribute('data-vc-cat') === f); }); }
      }
    }
    var th = e.target.closest('[data-vc-thumb]');
    if (th) { var m = document.querySelector('[data-vc-main]'); if (m) { m.src = th.getAttribute('data-vc-thumb'); m.removeAttribute('srcset'); } document.querySelectorAll('[data-vc-thumb]').forEach(function(x){ x.classList.toggle('is-on', x === th); }); }
    var q = e.target.closest('[data-vc-qty]');
    if (q) { var i = q.parentNode.querySelector('input'); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(q.getAttribute('data-vc-qty'), 10)); }
    var a = e.target.closest('[data-vc-variant-url]');
    if (a) {
      e.preventDefault();
      var box = document.getElementById('vc-variant-box');
      if (!box) { location.href = a.getAttribute('href'); return; }
      var url = a.getAttribute('data-vc-variant-url');
      var sid = box.getAttribute('data-section');
      box.style.opacity = '.5';
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid))
        .then(function(r){ return r.text(); })
        .then(function(h){
          var d = new DOMParser().parseFromString(h, 'text/html');
          var nb = d.getElementById('vc-variant-box');
          if (!nb) { location.href = url; return; }
          box.innerHTML = nb.innerHTML; box.style.opacity = '';
          history.replaceState(null, '', url);
          var img = box.querySelector('[data-vc-variant-img]');
          if (img && img.value) { var mm = document.querySelector('[data-vc-main]'); if (mm) { mm.src = img.value; mm.removeAttribute('srcset'); } }
          var av = box.querySelector('[data-vc-available]');
          var sb = document.querySelector('[data-vc-submit]');
          if (av && sb) { var ok = av.value === 'true'; sb.disabled = !ok; sb.textContent = ok ? 'Add to cart' : 'Sold out'; }
        })
        .catch(function(){ location.href = url; });
    }
  });
  document.addEventListener('change', function(e){
    var el = e.target;
    if (el.hasAttribute('data-vc-design')) {
      var art = el.closest('.vc-art');
      var yes = el.value.indexOf('Yes') === 0;
      art.classList.toggle('is-design', yes);
      art.querySelector('[data-vc-upload]').hidden = yes;
      art.querySelector('[data-vc-notes]').hidden = !yes;
      var fi = art.querySelector('.vc-file');
      if (yes) { fi.value = ''; fi.disabled = true; art.querySelector('[data-vc-file-label]').textContent = 'Upload your artwork'; art.querySelector('.vc-drop').classList.remove('has-file'); } else { fi.disabled = false; }
    }
    if (el.classList.contains('vc-file')) {
      var file = el.files && el.files[0];
      var wrap = el.closest('.vc-art');
      wrap.querySelector('[data-vc-file-label]').textContent = file ? 'Uploaded: ' + file.name : 'Upload your artwork';
      wrap.querySelector('.vc-drop').classList.toggle('has-file', !!file);
    }
  });
  document.addEventListener('submit', function(e){
    var form = e.target;
    var dv = form.getAttribute('data-vc-design-variant');
    if (!dv || form.dataset.vcSent) return;
    var pick = form.querySelector('[data-vc-design]:checked');
    if (!pick || pick.value.indexOf('Yes') !== 0) return;
    e.preventDefault();
    form.dataset.vcSent = '1';
    var btn = form.querySelector('[data-vc-submit]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(dv, 10), quantity: 1 }] }) })
      .catch(function(){})
      .then(function(){ form.submit(); });
  });
})();
